export const TILE_SIZE = 1
export const SIMULATION_PERIOD_S = 1 / 60
export const MAX_PREDICTED_FRAMES = 7
